<template>
  <div class="slider-wrapper">
    <div class="slider">
      <div class="slider__image-container">
        <div id="glass" class="image-magnifier-glass"></div>
        <img
          id="myimage"
          :src="getSelectedNavigationOption.pictures[index]"
          alt="Logo"
          class="slider__image"
        />
      </div>
      <div class="wrapper-button-previous">
        <SmallButtonWithTooltip
          tooltipText="Previous Graphical Products"
          tooltip_always_on="true"
          imageSource="assets/image/svg/back-arrow.svg"
          @click.native="previousImage"
        />
      </div>
      <div class="wrapper-button-next">
        <SmallButtonWithTooltip
          tooltipText="Next Graphical Product"
          tooltip_always_on="true"
          imageSource="assets/image/svg/right-arrow.svg"
          @click.native="nextImage"
        />
      </div>
      <div class="wrapper-bullet-buttons">
        <SmallButtonWithTooltip
          tooltipText="Start/Stop slideshow"
          tooltip_always_on="false"
          imageSource="assets/image/svg/play-pause.svg"
          @click.native="startSlideshow"
        />
        <SmallButtonWithTooltip
          tooltipText="Slow Down Slideshow"
          tooltip_always_on="false"
          imageSource="assets/image/svg/double-arrow-left.svg"
          @click.native="toggleSlideshowSpeed(SLOWDOWN)"
        />
        <SmallButtonWithTooltip
          tooltipText="Speed Up Slideshow"
          tooltip_always_on="false"
          imageSource="assets/image/svg/double-arrow-right.svg"
          @click.native="toggleSlideshowSpeed(SPEEDUP)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SmallButtonWithTooltip from "./SmallButtonWithTooltip.vue";

export default {
  components: {
    SmallButtonWithTooltip,
  },
  data() {
    return {
      SLOWDOWN: "slowdown",
      SPEEDUP: "speedup",

      index: 0,
      totalSteps: 0,
      autoSlideshow: true,
      slideshowSpeed: 1000,
      intervalId: 0,
      slideshowStarted: false,
    };
  },
  methods: {
    startSlideshow() {
      if (!this.slideshowStarted) {
        this.intervalId = setInterval(() => {
          if (this.autoSlideshow) {
            if (
              this.index ===
              this.getSelectedNavigationOption.pictures.length - 1
            ) {
              this.index = 0;
              return;
            }
            this.index++;
          }
        }, this.slideshowSpeed);
        this.slideshowStarted = true;
      } else {
        this.stopSlideshow();
      }
    },
    stopSlideshow() {
      clearInterval(this.intervalId);
      this.slideshowStarted = false;
    },
    previousImage() {
      this.stopSlideshow();
      if (this.index !== 0) {
        this.index--;
      } else {
        this.index = this.getSelectedNavigationOption.pictures.length - 1;
      }
    },
    nextImage() {
      this.stopSlideshow();
      if (this.index !== this.getSelectedNavigationOption.pictures.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
    },
    toggleSlideshowSpeed(direction) {
      this.slideshowStarted = false;
      clearInterval(this.intervalId);
      if (direction === this.SLOWDOWN) {
        this.slideshowSpeed += 500;
      } else {
        this.slideshowSpeed -= 500;
      }
      this.startSlideshow();
    },
    magnify(imgID, zoom) {
      console.log("magnify");
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);

      /* Create magnifier glass: */
      glass = document.getElementById("glass");

      /* Set background properties for the magnifier glass: */
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;

      /* Execute a function when someone moves the magnifier glass over the image: */
      glass.addEventListener("mousemove", (e) => this.moveMagnifier(e,w,h,bw,img,zoom,glass));
      img.addEventListener("mousemove", (e) => this.moveMagnifier(e,w,h,bw,img,zoom,glass));
    },
    moveMagnifier(e,w,h,bw,img,zoom,glass) {
      console.log("move");
      var pos, x, y;
      /* Prevent any other actions that may occur when moving over the image */
      //e.preventDefault();
      /* Get the cursor's x and y positions: */
      pos = getCursorPos(e);
      x = pos.x;
      y = pos.y;
      /* Prevent the magnifier glass from being positioned outside the image: */
      if (x > img.width - w / zoom) {
        x = img.width - w / zoom;
      }
      if (x < w / zoom) {
        x = w / zoom;
      }
      if (y > img.height - h / zoom) {
        y = img.height - h / zoom;
      }
      if (y < h / zoom) {
        y = h / zoom;
      }
      /* Set the position of the magnifier glass: */
      glass.style.left = x - w + "px";
      glass.style.top = y - h + "px";
      /* Display what the magnifier glass "sees": */
      glass.style.backgroundPosition =
        "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";

      glass.style.backgroundImage = "url('" + this.getSelectedNavigationOption.pictures[this.index] + "')";

      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /* Get the x and y positions of the image: */
        a = img.getBoundingClientRect();
        /* Calculate the cursor's x and y coordinates, relative to the image: */
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /* Consider any page scrolling: */
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },
  },
  computed: {
    getSelectedNavigationOption() {
      console.log(this.$store.getters.getSelectedNavigationOption);
      return this.$store.getters.getSelectedNavigationOption;
    },
  },
  mounted() {
    this.startSlideshow();
    this.magnify("myimage", 2);
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.slider-wrapper {
  position: relative;
  //overflow: hidden;
  height: 100%; /* Or set a fixed height */
}

/* SLIDER */
.slider-wrapper .slider {
  position: relative;
  height: 100%;
  white-space: nowrap;
  font-size: 0;
  //transition: 0.8s;
}

.slider__image-container {
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.slider__image-container:hover .image-magnifier-glass {
  opacity: 1;
}

.image-magnifier-glass {
  position: absolute;
  border: 3px solid $color-gray;
  border-radius: 50%;
  //cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 250px;
  height: 250px;
  opacity: 0;
}

.slider__image {
  //width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
}

//PREVIOUS, NEXT AND BULLETS

.wrapper-button-previous {
  display: inline-flex;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 2%;
}

.wrapper-button-next {
  display: inline-flex;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 90%;
}

.wrapper-bullet-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  z-index: 1;
  top: 92%;
  left: 38%;
}
</style>
